import * as types from './mutation-types'

export default {
  [types.CHANGEBOT] (state, data) {
    state.botinfo = data
  },
  [types.CHANGEMSGREPLY] (state, data) {
    state.editmsgreplyinfo = data
  },
  [types.CHANGEREPLY] (state, data) {
    state.replyinfo = data
  },
  [types.CHANGEFRIEND] (state, data) {
    state.friendinfo = data
  },
  [types.MYPROFILE] (state, data) {
    state.myprofile = data
  },
  [types.SHOWMEMBER] (state, data) {
    state.showmember = data
  },
  [types.MYNAME] (state, data) {
    state.myname = data
  },
  [types.CHANGEGROUP] (state, data) {
    state.groupinfo = data
  },
  [types.CHANGEGROUPMEMBER] (state, data) {
    state.groupmember = data
  },
  [types.CHANGERIGHTTOOL] (state, data) {
    state.layout = data
  },
  [types.SENDREQUEST] (state, data) {
    state.sendrequest = data
  },
  [types.LISTSENDREQUEST] (state, data) {
    state.listsendrequest = data
  },
  [types.REQUEST] (state, data) {
    state.request = data
  },
  [types.LISTREQUEST] (state, data) {
    state.listrequest = data
  },
  [types.LISTFRIEND] (state, data) {
    state.listfriend = data
  },
  [types.LISTCHAT] (state, data) {
    state.listchat = data
  },
  [types.GROUPREQ] (state, data) {
    state.groupreq = data
  },
  [types.LISTGROUPREQ] (state, data) {
    state.listgroupreq = data
  },
  [types.LISTGROUP] (state, data) {
    state.listgroup = data
  },
  [types.TOKENROOM] (state, data) {
    state.tokenroom = data
  },
  [types.GROUPIDREMOVE] (state, data) {
    state.groupidremove = data
  },
  [types.CHATFILE] (state, data) {
    state.chatfile = data
  },
  [types.CHATIMAGE] (state, data) {
    state.chatimage = data
  },
  [types.LISTBOT] (state, data) {
    state.listbot = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js